import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { IAssetDisposeDto } from '~/models/modules/Asset/Transactions/dispose/assetDisposeDto';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { AssetDisposeAuthorizationActionModel } from '~/models/AssetDisposeAuthorizationActionModel';

@Injectable({ providedIn: 'root' })
export class AssetDisposeTransactionsService extends ApiServiceBase {
  FromInventory: any = [];
  constructor(injector: Injector, private http: HttpClient) {
      super(injector);
      this.setBase(API_NAMES.assets);
  }
  getDisposeTransactionHistoryGrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }
  createDisposeTransaction(model:IAssetDisposeDto){
    return this.client.post<any>(this._url(), model);
  }
  validatePersonLocation(model:IAssetDisposeDto){
    return this.client.post<any>(this._url(`/validate-location-person`), model);
  }
  validateCheckSettings(model:IAssetDisposeDto){
    return this.client.post<any>(this._url(`/validate-check-settings`), model);
  }

  getDisposeAuthorization(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<any[]>(this._url(`/grid-data_Authorization`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  updateAuthorizationStatus(model: AssetDisposeAuthorizationActionModel) {
    return this.client.post(this._url(`/Authorization/UpdateStatus`), model);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/DisposeTransaction${v}`);
}
}
